interface CheckIconProps {
  width?: number;
  height?: number;
  fill?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({
  width = 24,
  height = 24,
  fill = "white"
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16.17L4.83 12L3.41 13.41L9 19L21 7L19.59 5.59L9 16.17Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckIcon;
